const InsightsConfig = {
  MAX_POSTS_PER_METRIC: 3,
  REPEAT_SYNC_LIMIT_IN_MINUTES: 30,
  SYNC_ERROR_MESSAGES_TO_SHOW_LIMIT: 5,
  PAGE_PERFORMANCE_REPORT_POSTS_PER_METRIC: 5,
};

export default InsightsConfig;
